import _ from 'lodash';

export const kindFormatted = kind => _.chain(kind)
  .split('_')
  .map(_.capitalize)
  .join(' ')
  .value();
